<template>
	<section :class="['block-wrapper', componentClass, colorMode, {visible: visible, ready: ready}]">
		<CustomPostContent :data="data"></CustomPostContent>
	</section>
</template>

<script>
import BaseBlock from '@/components/blocks/Base'

export default {
	extends: BaseBlock,
	data() {
		return {
			defaultColorMode: 'light',
			componentClass: 'news-single top-header-padding'
		}
	},
	components: {
			CustomPostContent: () => import('@/components/blocks/CustomPostContent'),
	}
}
</script>

<style lang="scss">
	@import "~@/styles/scss/component/news-single";
</style>